import { useFormatter } from '@grandvisionhq/frk-routing';
import { getProductKeyFromCTType } from '@grandvisionhq/utils';

const useGetProductLinkFormatter = ()=>{
    const formatter = useFormatter();
    return (slug, sku, productType)=>{
        const route = formatter({
            route: 'products.detail',
            params: {
                slug,
                sku,
                key: getProductKeyFromCTType(productType)
            }
        });
        return typeof route === 'string' ? route : '#';
    };
};

export { useGetProductLinkFormatter };
//# sourceMappingURL=use-get-product-link-formatter.js.map
